import React, {useEffect, useState} from 'react'
import {withTranslation} from 'react-i18next'

import {usersService} from 'services'
import requestHandler from 'utils/requestHandler'
import useUserContext from 'components/User/useUserContext'
import SideWelcomeBack from 'modules/UserProfile/SideWelcomeBack'

const UserProfile = ({t, history}) => {
  const {user} = useUserContext()

  const [data, setData] = useState(undefined)

  useEffect(() => {
    setData(undefined)

    requestHandler(() => usersService.getOrderGroups(user.customerProfile.uuid, {take: 999, skip: 0}), 'json')
      .then(r => {
        if (r.success) setData(r.data)
        else setData(null)
      })
  }, [user.customerProfile.uuid])

  return (
    <div className='formDesigned'>
      <div>
        <div className='formDesigned-block'>
          <h6>{t('Latest orders')}</h6>

          {data ? (
            data.items.length ? (
              data.items.map(e => <div>{JSON.stringify(e)}</div>)
            ) : (
              'no orders yet'
            )
          ) : data === undefined ? (
            'loading...'
          ) : (
            'error'
          )}
        </div>
      </div>

      <div>
        <SideWelcomeBack t={t} user={user} history={history}/>
      </div>
    </div>
  )
}

export default withTranslation()(UserProfile)
